<script>
import UploadNeededFileModal from '@/components/modal/repair-file/UploadNeededFileModal.vue';
import { auth as $store } from '@/store/AuthModule';
import { handleResponseError, shouldShowTooltip } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator';
import { VPhoneInput } from 'v-phone-input';
import RegionCodeService from '@/services/RegionCodeService';
import { RepairFile } from '@/models/RepairFile';
import ErpStoreService from '@/services/repairModule/erpStore/ErpStoreService'
import RepairFileProspectService from '@/services/repairModule/repairFile/RepairFileProspectService'
import RepairFileService from '@/services/RepairFileService'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'

export default {
  name: 'SubStepProspectInformationClient',
  components: { UploadNeededFileModal, VPhoneInput },
  props: {
    currentRepairFileProps: RepairFile
  },
  data() {
    return {
      created: false,
      currentRepairFile: null,

      formValid: false,
      loading: false,
      selectedCountry: null,
      allCountries: [],
      zones: [],
      lastname: null,
      company: null,
      email: null,
      phoneNumber: null,

      buyProofFile: null,
      guaranteeExtensionProofFile: null,
      asbestosProofFile: null,
      forceSupportProofFile: null,

      selectedContextStore: null,
      erpStoreClientList: [],
      selectedStoreClientId: null,
      erpClientName: null,
      companyNotfound: false,

      requiredRules: Validator.requiredRules,
      emailRules: Validator.emailRules
    }
  },
  watch: {
    selectedStoreClientId() {
      const erpStoreClientListIndex =
        this.erpStoreClientList.findIndex(element => element.technicalId === this.selectedStoreClientId)

      if (erpStoreClientListIndex !== -1) {
        const erpStoreClientSelected = this.erpStoreClientList[erpStoreClientListIndex]
        this.company = erpStoreClientSelected.clientName
      }
    }
  },
  async created() {
    try {
      this.currentRepairFile = this.currentRepairFileProps
      this.patchFileInput()
      const response = await RegionCodeService.getRegionCodeList()
      this.zones = Object.values(response.item_list).map(option => ({
        technical_id: option.technical_id,
        title: ` ${ this.reformatData(option.region) } ${ this.reformatData(option.country) }`
      }));
      this.allCountries = await this.getCountryCode(response.item_list)

      this.selectedContextStore = this.$store.getters['auth/getRepairFileStoreSelected']
      if (this.selectedContextStore.erpSupportStatus === true) {
        const response = await ErpStoreService.getItechStoreClientList(
          this.selectedContextStore.technical_id)
        this.erpStoreClientList = response.itemList
      }
      this.created = true
    } catch (error) {
      handleResponseError(error)
    }
  },
  methods: {
    shouldShowTooltip,
    reformatData(string) {
      const lowercaseString = string.toLowerCase();
      const trimmedString = lowercaseString.trim();
      const normalizedString = trimmedString
        .replace(/\s*-\s*/g, '-')
        .replace(/\s+/g, ' ');

      return normalizedString.replace(/(?:^|\s)(\p{Ll})/gu, function (match) {
        return match.toUpperCase();
      });
    },
    getItemTitle(item) {
      return `${item.clientCode} - ${item.clientName}`
    },
    getCountryCode(zones) {
      return zones.map((item) => {
        return item.country_code
      })
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    validationFormInputFile() {
      return this.displayForceSupportAttachment() && !this.forceSupportProofFile
        || (this.displayGuaranteeExtensionAttachment() && !this.guaranteeExtensionProofFile
          && this.displayForceSupportAttachment() && !this.forceSupportProofFile)
        || this.displayPurchaseAttachment() && !this.buyProofFile
        || this.displayAsbestosAttachment() && !this.asbestosProofFile
    },
    async openInputModal(title, attachmentType) {
      const response = await this.$refs.uploadNeededFileModal.show({
        currentRepairFile: this.currentRepairFile,
        attachmentType: attachmentType,
        title: title
      })

      if (response.confirmed) {
        this.currentRepairFile = await RepairFileService.get(this.currentRepairFile.boomerang_id)
        this.patchFileInput()
      } else {
        this.currentRepairFile = await RepairFileService.get(this.currentRepairFile.boomerang_id)
        this.patchFileInput()
      }
    },
    patchFileInput() {
      this.lastname = this.lastname === null ? this.currentRepairFile.lastname : this.lastname
      this.phoneNumber = this.phoneNumber === null ? this.currentRepairFile.phone_number : this.phoneNumber
      this.email = this.email === null ? this.currentRepairFile.email : this.email
      this.company = this.company === null ? this.currentRepairFile.company : this.company

      if (this.selectedStoreClientId === null && this.currentRepairFile.erp_intern_client_id !== -1) {
        this.selectedStoreClientId = this.currentRepairFile.erp_intern_client_id !== -1
          ? this.currentRepairFile.erp_intern_client_id : null
      }

      if (!this.companyNotfound) {
        if (this.currentRepairFile.erp_intern_client_id === -1 && this.currentRepairFile.company === null) {
          this.companyNotfound = this.currentRepairFile.with_erp_intern
        } else {
          this.companyNotfound = !this.currentRepairFile.with_erp_intern
        }
      }

      this.buyProofFile = this.removeTextBeforeLastDash(this.currentRepairFile.product_buy_proof_file_path) || null;
      this.guaranteeExtensionProofFile = this.removeTextBeforeLastDash(this.currentRepairFile.product_guarantee_extension_proof_file_path) || null;
      this.asbestosProofFile = this.removeTextBeforeLastDash(this.currentRepairFile.product_asbestos_proof_file_path) || null;
      this.forceSupportProofFile = this.removeTextBeforeLastDash(this.currentRepairFile.product_force_support_proof_file_path) || null;
    },
    removeTextBeforeLastDash(inputString) {
      if (!inputString)
        return null
      const parts = inputString.split('-');
      if (parts.length > 1) {
        return parts.slice(1).join('-');
      } else {
        return inputString;
      }
    },
    async submit() {
      let data = {
        'status_detail': RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED,
        'is_complete_update': 'True',
        'requestor_collaborator_id': this.getCurrentCollaborator().technical_id,
        'lastname': this.lastname,
        'company': this.company,
        'phone_number': this.phoneNumber,
        'email': this.email,
        'is_store_with_erp_intern': 'False'
      }

      if (this.selectedContextStore?.erpSupportStatus === true) {
        if (this.companyNotfound === false) {
          data = {...data, selected_erp_store_client_id: this.selectedStoreClientId}
          data = {...data, is_store_with_erp_intern: 'True'}
        }
      }

      await this.updateSubStepProspectInformationClient(data, false)
    },
    async updatePartialData() {
      let data = {
        'status_detail': RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED,
        'requestor_collaborator_id': this.getCurrentCollaborator().technical_id,
        'is_store_with_erp_intern': 'False',
        'lastname': this.lastname || '',
        'company': this.company || null,
        'phone_number': this.phoneNumber || null,
        'email': this.email || ''
      }

      if (this.selectedContextStore?.erpSupportStatus === true) {
        if (this.companyNotfound === false && this.selectedStoreClientId) {
          data = { ...data, selected_erp_store_client_id: this.selectedStoreClientId }
          data = { ...data, is_store_with_erp_intern: 'True' }
        }
      }

      await this.updateSubStepProspectInformationClient(data, true)
    },
    async updateSubStepProspectInformationClient(data, isPartial) {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        await RepairFileProspectService.update(repairFileId, formData)
        if (isPartial === false) {
          this.$emit('change-prospect-sub-step')
        }
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    displayAttachmentPart() {
      return this.displayForceSupportAttachment()
        || this.displayGuaranteeExtensionAttachment()
        || this.displayPurchaseAttachment()
        || this.displayAsbestosAttachment()
    },
    displayForceSupportAttachment() {
      if (this.currentRepairFile.status_guarantee === 'FORCE_GUARANTEE'
        && !this.currentRepairFile.product_force_support_proof_file_path) {
        return true
      } else if (this.currentRepairFile.product_force_support_proof_file_path) {
        return true
      } else if (this.currentRepairFile.product_force_support_proof_needed) {
        return true
      } else {
        return false
      }
    },
    displayGuaranteeExtensionAttachment() {
      if (this.currentRepairFile.status_guarantee === 'EXTENSION'
        && !this.currentRepairFile.product_guarantee_extension_proof_file_path) {
        return true
      } else if (this.currentRepairFile.product_guarantee_extension_proof_file_path) {
        return true
      } else if (this.currentRepairFile.product_guarantee_extension_proof_needed) {
        return true
      } else {
        return false
      }
    },
    displayPurchaseAttachment() {
      if (this.currentRepairFile.status_guarantee === 'COMMERCIAL'
        && !this.currentRepairFile.product_buy_proof_file_path) {
        return true
      } else if (this.currentRepairFile.product_buy_proof_file_path) {
        return true
      } else if (this.currentRepairFile.product_buy_proof_needed) {
        return true
      } else {
        return false
      }
    },
    displayAsbestosAttachment() {
      if (this.currentRepairFile.product_asbestos_proof_needed) {
        return true
      } else if (this.asbestosProofFile) {
        return true
      } else {
        return false
      }
    },
    switchToCompanyNotFound() {
      this.companyNotfound = true
    }
  }
}
</script>

<template>
  <v-form
    ref="formStepProspectInformationClient"
    v-if="created"
    v-model="formValid"
    @submit.prevent="submit"
  >
    <!--RULES WITHOUT ERP INTERN-->
    <v-col
      v-if="selectedContextStore?.erpSupportStatus !== true"
      class="mt-5 pl-0 pt-0">
      <p class="information-content">{{ $t('FILE_STEP_CREATE_FOLDER.HELP_TEXT.RULES') }}</p>
    </v-col>
    <!--RULES WITH ERP INTERN-->
    <v-col
      v-if="selectedContextStore?.erpSupportStatus === true"
      class="mt-5 pl-0 pt-0">
      <p class="information-content">{{ $t('FILE_STEP_CREATE_FOLDER.HELP_TEXT.RULES_ERP') }}</p>
    </v-col>

    <!-- GENERAL INFORMATION PART-->
    <v-row md="12" class="row-input-one">
      <!--COMPANY NAME-->
      <v-col v-if="selectedContextStore?.erpSupportStatus !== true || companyNotfound === true">
        <p data-custom="true" class="content-title">
          {{ $t('FILE_STEP_CREATE_FOLDER.FORM.COMPANY') }}
        </p>
        <v-text-field
          v-model="company"
          :rules="requiredRules"
          required
        />
      </v-col>

      <!--COMPANY NAME SELECTOR-->
      <v-col cols="12" md="6"
             v-if="selectedContextStore?.erpSupportStatus === true && companyNotfound !== true"
      >
        <p data-custom="true" class="content-title">
          {{ $t('FILE_STEP_CREATE_FOLDER.FORM.COMPANY_SELECTOR') }}
        </p>
        <v-autocomplete
          id="select-store-client-type"
          v-model="selectedStoreClientId"
          :items="erpStoreClientList"
          :no-data-text="$t('COMMON.NO_DATA')"
          :rules="requiredRules"
          :item-title="getItemTitle"
          item-value="technicalId"
          required
          clearable
        >
          <template v-slot:selection="{ item }">
            <v-chip size="small">
              <span>{{ item.title }}</span>
            </v-chip>
          </template>
          <template v-slot:item="{ item, props }">
            <v-list-item
              :title="item.title"
              :value="item.value"
              v-bind="props"
            >
              <v-tooltip
                v-if="shouldShowTooltip(item, 'select-store-client-type')"
                activator="parent"
                location="bottom left"
              >
                {{ item.title }}
              </v-tooltip>
            </v-list-item>
          </template>
        </v-autocomplete>
        <p class="company-not-found"
           @click="switchToCompanyNotFound()"
        >
          {{ $t('FILE_STEP_CREATE_FOLDER.HELP_TEXT.COMPANY_NOT_FOUND_RULE') }}
        </p>
      </v-col>

      <!--CLIENT NAME-->
      <v-col>
        <p data-custom="true" data-rgpd="true" class="content-title">
          {{ $t('FILE_STEP_CREATE_FOLDER.FORM.NAME') }}
        </p>
        <v-text-field
          v-model="lastname"
          :rules="requiredRules"
          required
        />
      </v-col>
    </v-row>

    <v-row md="12">
      <!--EMAIL CLIENT-->
      <v-col>
        <p data-custom="true" data-rgpd="true" class="content-title">
          {{ $t('FILE_STEP_CREATE_FOLDER.FORM.MAIL') }}
        </p>
        <v-text-field
          v-model="email"
          :rules="[...requiredRules, ...emailRules]"
          required
        />
      </v-col>
      <!--PHONE NUMBER CLIENT-->
      <v-col>
        <p data-rgpd="true" class="content-title">
          {{ $t('FILE_STEP_CREATE_FOLDER.FORM.PHONE') }}
        </p>
        <v-phone-input
          v-model="phoneNumber"
          v-model:country="selectedCountry"
          :includeCountries="allCountries"
        />
      </v-col>
    </v-row>
    <v-col class="pl-0">
      <p class="information-content-end">{{ $t('FILE_STEP_CREATE_FOLDER.HELP_TEXT.RGPD_RULES') }}</p>
    </v-col>
    <!-- GENERAL INFORMATION PART END -->

    <!-- ATTACHMENT PART -->
    <div v-if="displayAttachmentPart()">
      <v-col md="12" class="pa-0 pb-10">
        <h1 class="information-content-title">
          {{ $t('FILE_STEP_CREATE_FOLDER.SUB_TITLE.ATTACHMENT') }}
        </h1>
      </v-col>
      <!--INPUT FILES-->
      <v-col class="pa-0">
        <!--BILLING FILE INPUT-->
        <div class="d-flex flex-row"
             v-if="displayPurchaseAttachment() || displayGuaranteeExtensionAttachment()"
        >
          <div
            class="cursor-pointer"
            @click.stop.prevent="openInputModal(
              $t('FILE_STEP_CREATE_FOLDER.MODAL.TITLE.BILLING'),
              'PURCHASE_PROOF')">
            <div class="file-input d-flex flex-row">
              <img alt="download-svg"
                   class="download-svg mr-4"
                   src="@/assets/icons/file/download.svg"/>
              <div v-if="!buyProofFile" class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.BILLING') }}
                </p>
                <p class="file-input-info">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT') }}
                </p>
                <img alt="info-svg" class="info-svg" src="@/assets/icons/file/info.svg"/>
              </div>
              <div v-else class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.BILLING') }} :
                </p>
                <p class="file-input-info">
                  {{ buyProofFile }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!buyProofFile"
               class="d-flex flex-row warning-content">
            <img alt="info-svg" class="error-svg" src="@/assets/icons/file/cross-red.svg"/>
            <p class="file-input-warning">
              {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT_WARNING') }}
            </p>
          </div>
        </div>

        <!--EXTENSION GUARANTEE INPUT-->
        <div class="d-flex flex-row"
             v-if="displayGuaranteeExtensionAttachment()">
          <div
            class="cursor-pointer"
            @click.stop.prevent="openInputModal(
              $t('FILE_STEP_CREATE_FOLDER.MODAL.TITLE.EXTENSION_GUARANTEE'),
              'GUARANTEE_EXTENSION_PROOF')">
            <div class="file-input d-flex flex-row">
              <img alt="download-svg"
                   class="download-svg mr-4"
                   src="@/assets/icons/file/download.svg"/>
              <div v-if="!guaranteeExtensionProofFile" class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.EXTENSION_GUARANTEE') }}
                </p>
                <p class="file-input-info">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT') }}
                </p>
                <img alt="info-svg" class="info-svg" src="@/assets/icons/file/info.svg"/>
              </div>
              <div v-else class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.EXTENSION_GUARANTEE') }} :
                </p>
                <p class="file-input-info">
                  {{ guaranteeExtensionProofFile }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!guaranteeExtensionProofFile"
               class="d-flex flex-row warning-content">
            <img alt="info-svg" class="error-svg" src="@/assets/icons/file/cross-red.svg"/>
            <p class="file-input-warning">
              {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT_WARNING') }}
            </p>
          </div>
        </div>

        <!--ASBESTOS INPUT-->
        <div class="d-flex flex-row"
             v-if="displayAsbestosAttachment()">
          <div
            class="cursor-pointer"
            @click.stop.prevent="openInputModal(
              $t('FILE_STEP_CREATE_FOLDER.MODAL.TITLE.ASBESTOS_SHEET'),
              'ASBESTOS_PROOF')">
            <div class="file-input d-flex flex-row">
              <img alt="download-svg"
                   class="download-svg mr-4"
                   src="@/assets/icons/file/download.svg"/>
              <div v-if="!asbestosProofFile" class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.ASBESTOS_SHEET') }}
                </p>
                <p class="file-input-info">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT') }}
                </p>
                <img alt="info-svg" class="info-svg" src="@/assets/icons/file/info.svg"/>
              </div>
              <div v-else class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.ASBESTOS_SHEET') }} :
                </p>
                <p class="file-input-info">
                  {{ asbestosProofFile }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!asbestosProofFile"
               class="d-flex flex-row warning-content">
            <img alt="info-svg"
                 class=" error-svg warning-svg"
                 src="@/assets/icons/file/info.svg"/>

            <p class="file-input-warning asbestos-warning">
              {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT_WARNING_ASBESTOS') }}
            </p>
          </div>
        </div>

        <!--FORCE SUPPORT INPUT-->
        <div class="d-flex flex-row"
             v-if="displayForceSupportAttachment()">
          <div
            class="cursor-pointer"
            @click.stop.prevent="openInputModal($t('FILE_STEP_CREATE_FOLDER.MODAL.TITLE.FORCE_GUARANTEE'),'force_support_proof_file')">
            <div class="file-input d-flex flex-row">
              <img alt="download-svg" class="download-svg mr-4" src="@/assets/icons/file/download.svg"/>
              <div v-if="!forceSupportProofFile" class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.FORCE_GUARANTEE') }}
                </p>
                <p class="file-input-info">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT') }}
                </p>
                <img alt="info-svg" class="info-svg" src="@/assets/icons/file/info.svg"/>
              </div>
              <div v-else class="d-flex flex-row">
                <p class="file-input-name">
                  {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.FORCE_GUARANTEE') }} :
                </p>
                <p class="file-input-info">
                  {{ forceSupportProofFile }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="!forceSupportProofFile"
               class="d-flex flex-row warning-content">
            <img alt="info-svg" class="error-svg" src="@/assets/icons/file/cross-red.svg"/>
            <p class="file-input-warning">
              {{ $t('FILE_STEP_CREATE_FOLDER.FILE_INPUT.DEFAULT_WARNING') }}
            </p>
          </div>
        </div>
      </v-col>
      <!-- ATTACHMENT PART END -->
    </div>

    <v-btn
      :disabled="!formValid || validationFormInputFile() || loading"
      :loading="loading"
      class="boom-button mt-4 pl-15 pr-15"
      variant="outlined"
      type="submit"
    >
      {{ $t('COMMON.BUTTON.NEXT_STEP') }}
      <img alt="arrow_small-icon" class="arrow-svg" src="@/assets/icons/file/arrow_small_right.svg"/>
    </v-btn>
  </v-form>
  <UploadNeededFileModal ref="uploadNeededFileModal"/>
</template>

<style scoped>
.v-card {
  padding: 40px !important;
}

.content-title {
  margin-bottom: 10px;
}

.information-content-title {
  margin-top: 40px;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
}

.information-content {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 8px 20px;
  background-color: #EFEFEF;
  border-radius: 20px;
  width: fit-content;
}

.information-content-end {
  color: #727272;
  font-size: 18px;
  font-style: italic;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}

.file-input {
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 8px 20px;
  background-color: #EFEFEF;
  border-radius: 20px;
  width: fit-content;
  border-color: white;
}

.file-input-name {
  font-size: 18px;
  margin-right: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}

.file-input-info {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #727272;
}

.file-input-warning {
  color: var(--error-color);
  margin: auto;
}

.warning-content {
  margin-bottom: 10px;
  gap: 10px;
}

.row-input-one {
  padding-top: 8px;
}

.download-svg {
  margin-right: 10px;
  height: 18px;
}

.info-svg {
  margin-top: 1px;
  margin-left: 10px;
  height: 18px;
}

.error-svg {
  margin: auto;
  height: 18px;

}

.arrow-svg {
  filter: invert(89%) sepia(98%) saturate(1%) hue-rotate(266deg) brightness(110%) contrast(97%)
}

.asbestos-warning {
  color: var(--warning-color);
}

.warning-svg {
  filter: invert(78%) sepia(48%) saturate(3662%) hue-rotate(351deg) brightness(102%) contrast(103%);
  transform: rotate(180deg);
}

.company-not-found {
  font-size: smaller;
  font-style: italic;
  text-decoration: underline;
  cursor: pointer;
}
</style>

